interface FilterPanelProps {
  year: string;
  rating: string;
  genre: string;
  genreOptions: string[];
  onYearChange: (value: string) => void;
  onRatingChange: (value: string) => void;
  onGenreChange: (value: string) => void;
  onReset: () => void;
}

const yearOptions = [
  { value: "all", label: "全部年份" },
  { value: "1990", label: "九十年代" },
  { value: "2000", label: "二〇〇〇年代" },
  { value: "2010", label: "二〇一〇年代" },
  { value: "2020", label: "二〇二〇年代" },
];

const ratingOptions = [
  { value: "all", label: "全部评分" },
  { value: "8", label: "8 分以上" },
  { value: "7", label: "7 分以上" },
];

export default function FilterPanel({
  year,
  rating,
  genre,
  genreOptions,
  onYearChange,
  onRatingChange,
  onGenreChange,
  onReset,
}: FilterPanelProps) {
  const chipClass = (active: boolean) =>
    `whitespace-nowrap rounded-full border px-3 py-1.5 text-xs transition-colors ${
      active
        ? "border-accent-500 bg-accent-500 text-background-50"
        : "border-background-300 bg-background-50 text-foreground-600 hover:border-primary-400 hover:text-accent-600"
    }`;

  return (
    <div className="flex flex-col gap-6">
      <div>
        <h3 className="mb-3 flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.16em] text-foreground-500">
          <i className="ri-calendar-line text-sm" />
          上映年份
        </h3>
        <div className="flex flex-wrap gap-2">
          {yearOptions.map((option) => (
            <button
              key={option.value}
              type="button"
              onClick={() => onYearChange(option.value)}
              className={chipClass(year === option.value)}
            >
              {option.label}
            </button>
          ))}
        </div>
      </div>

      <div>
        <h3 className="mb-3 flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.16em] text-foreground-500">
          <i className="ri-star-line text-sm" />
          评分等级
        </h3>
        <div className="flex flex-wrap gap-2">
          {ratingOptions.map((option) => (
            <button
              key={option.value}
              type="button"
              onClick={() => onRatingChange(option.value)}
              className={chipClass(rating === option.value)}
            >
              {option.label}
            </button>
          ))}
        </div>
      </div>

      <div>
        <h3 className="mb-3 flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.16em] text-foreground-500">
          <i className="ri-price-tag-3-line text-sm" />
          类型标签
        </h3>
        <div className="flex flex-wrap gap-2">
          <button type="button" onClick={() => onGenreChange("all")} className={chipClass(genre === "all")}>
            全部类型
          </button>
          {genreOptions.map((option) => (
            <button
              key={option}
              type="button"
              onClick={() => onGenreChange(option)}
              className={chipClass(genre === option)}
            >
              {option}
            </button>
          ))}
        </div>
      </div>

      <button
        type="button"
        onClick={onReset}
        className="mt-1 flex w-fit items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-3 py-2 text-xs text-foreground-600 transition-colors hover:border-accent-400 hover:text-accent-600"
      >
        <i className="ri-refresh-line" />
        重置全部筛选
      </button>
    </div>
  );
}